module.exports = __webpack_public_path__ + "img/size.0c31c8fe.svg";